module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_c('span', [_vm._v("我的页面配置 / 新增")]), _vm._v(" "), _c('el-button', {
    staticClass: "back",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-wrapper"
  }, [_c('el-form', {
    ref: "formRef",
    staticClass: "advert-popup-form",
    attrs: {
      "label-width": "120px",
      "label-position": "left",
      "model": _vm.formData,
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "类型",
      "prop": "type"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择类型"
    },
    model: {
      value: (_vm.formData.type),
      callback: function($$v) {
        _vm.$set(_vm.formData, "type", $$v)
      },
      expression: "formData.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "运动服务",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "常用功能",
      "value": 2
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "模块ID",
      "prop": "moduleId"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入ID"
    },
    model: {
      value: (_vm.formData.moduleId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "moduleId", $$v)
      },
      expression: "formData.moduleId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入名称"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "顺序"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1
    },
    model: {
      value: (_vm.formData.order),
      callback: function($$v) {
        _vm.$set(_vm.formData, "order", $$v)
      },
      expression: "formData.order"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "链接",
      "prop": "jumpUrl"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formData.jumpUrl),
      callback: function($$v) {
        _vm.$set(_vm.formData, "jumpUrl", $$v)
      },
      expression: "formData.jumpUrl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "popup-prompt-form-item",
    attrs: {
      "label": "是否弹窗提示",
      "required": ""
    }
  }, [_c('div', {
    staticClass: "popup-prompt-row"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.formData.isPopup),
      callback: function($$v) {
        _vm.$set(_vm.formData, "isPopup", $$v)
      },
      expression: "formData.isPopup"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), (_vm.formData.isPopup === 1) ? _c('el-input', {
    staticClass: "popup-prompt-input",
    attrs: {
      "maxlength": "20",
      "placeholder": "请填写弹窗内容，最多20个字"
    },
    model: {
      value: (_vm.formData.popupContent),
      callback: function($$v) {
        _vm.$set(_vm.formData, "popupContent", $$v)
      },
      expression: "formData.popupContent"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "popup-prompt-example"
  }, [_c('span', {
    staticClass: "popup-prompt-example-label"
  }, [_vm._v("示例")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.popupPromptExampleImg,
      "alt": "弹窗示例"
    }
  })])], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "素材",
      "prop": "iconUrl"
    }
  }, [_c('SUpload', {
    attrs: {
      "accept": "image/*",
      "type": "drag",
      "size": 50,
      "actionUrl": "/adminapi/v1/basicTools/upload/one?uploadImageType=1",
      "show-file-list": false
    },
    model: {
      value: (_vm.formData.iconUrl),
      callback: function($$v) {
        _vm.$set(_vm.formData, "iconUrl", $$v)
      },
      expression: "formData.iconUrl"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "supload-tips"
  }, [_vm._v("\n          建议尺寸40*40，大小≤50KB，优先SVG其次png\n        ")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学校",
      "prop": "scopeType",
      "required": ""
    }
  }, [_c('div', {
    staticClass: "school-section"
  }, [_c('div', {
    staticClass: "school-scope-row"
  }, [_c('span', {
    staticClass: "label-text"
  }, [_vm._v("涉及院系：")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.formData.scopeType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "scopeType", $$v)
      },
      expression: "formData.scopeType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("部分")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "campus-zone-section"
  }, [_c('div', {
    staticClass: "section-label"
  }, [_vm._v("\n              " + _vm._s(_vm.formData.scopeType === 1 ? "屏蔽校区" : "应用校区") + "\n            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "margin-bottom": "8px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "flex": "1",
      "margin-right": "8px"
    },
    attrs: {
      "placeholder": "请选择校区",
      "filterable": ""
    },
    model: {
      value: (_vm.selectedCampusUnid),
      callback: function($$v) {
        _vm.selectedCampusUnid = $$v
      },
      expression: "selectedCampusUnid"
    }
  }, _vm._l((_vm.campusZoneList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.handleAddCampus
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('div', {
    staticClass: "campus-list-wrap"
  }, _vm._l((_vm.formData.campusList), function(item) {
    return _c('div', {
      key: item.value,
      staticClass: "campus-item"
    }, [_c('span', [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "text",
        "icon": "circle-close"
      },
      on: {
        "click": function($event) {
          return _vm.handleDeleteCampus(item.value)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "campus-footer"
  }, [_vm._v("\n              共计" + _vm._s(_vm.formData.campusList.length) + "所学校\n            ")])])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.clickSave()
      }
    }
  }, [_vm._v("保存")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-29efc13e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/AdvertisingSpace/MinePage/MineDetail.vue
// module id = 976
// module chunks = 0